var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbWhiteBorder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_137",
    "data-name": "Gruppe 137",
    transform: "translate(-510 -1504)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 52.5,
    cy: 52.5,
    r: 52.5,
    transform: "translate(510 1504)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_127",
    "data-name": "Pfad 127",
    d: "M759.692,1371.953a5.312,5.312,0,0,0-5.451-5.15H734.182c.782-3.028,2.341-9.571,2.341-13.6,0-5.041-3.189-7.335-6.149-7.335-2.71,0-4.754,1.8-4.754,4.2,0,11.381-10.058,19.311-19.08,19.311h-8.177a1.327,1.327,0,0,0-1.363,1.287v23.173a1.327,1.327,0,0,0,1.363,1.287c12.492,0,16.763,1.733,20.2,3.126a22.389,22.389,0,0,0,9.785,2.024h17.717a5.312,5.312,0,0,0,5.451-5.15,4.91,4.91,0,0,0-.924-2.863,5.19,5.19,0,0,0,3.65-4.861,4.912,4.912,0,0,0-.924-2.863,5.191,5.191,0,0,0,3.65-4.861,4.911,4.911,0,0,0-.924-2.863A5.191,5.191,0,0,0,759.692,1371.953Z",
    transform: "translate(-165.885 178.479)",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbWhiteBorder);
export default __webpack_public_path__ + "static/media/thumb_white_border.1b822bf1f676e047d8cc73e39c4cb64f.svg";
export { ForwardRef as ReactComponent };